// Navigation Timing collector. One event per hard navigation. We pull from
// PerformanceObserver('navigation', buffered: true) instead of the deprecated
// performance.timing API so it Just Works for bfcache restores too (the
// observer will not fire a second time on bfcache restore; SPA route changes
// are handled by spa.js).

import { observePerf, now } from '../safe.js';
import { EVENT_TYPES } from '../schema.js';
import { shouldSample } from '../config.js';

export function initNavigation(viewIdProvider, emit) {
  observePerf('navigation', (entries) => {
    if (!shouldSample(EVENT_TYPES.NAV_TIMING)) return;
    for (const n of entries) emit(toEvent(n, viewIdProvider()));
  });
}

function toEvent(n, viewId) {
  // All deltas computed from PerformanceNavigationTiming. Several fields can
  // be 0 (e.g. preconnect already established) — those are valid and stored
  // verbatim; the backend's percentiles handle zero buckets correctly.
  return {
    id: viewId + ':nav',
    t: now(),
    tp: EVENT_TYPES.NAV_TIMING,
    n: 'navigation',
    mv: n.duration || 0,
    mu: 'ms',
    mr: '',
    mnt: n.type || '',
    dim: { nav_type: n.type || '' },
    met: {},

    nav_dns_ms:             clamp(n.domainLookupEnd - n.domainLookupStart),
    nav_tcp_ms:             clamp(n.connectEnd - n.connectStart),
    nav_ssl_ms:             n.secureConnectionStart > 0 ? clamp(n.connectEnd - n.secureConnectionStart) : 0,
    nav_ttfb_ms:            clamp(n.responseStart - n.requestStart),
    nav_response_ms:        clamp(n.responseEnd - n.responseStart),
    nav_dom_interactive_ms: clamp(n.domInteractive - n.startTime),
    nav_dom_complete_ms:    clamp(n.domComplete - n.startTime),
    nav_load_event_ms:      clamp(n.loadEventEnd - n.startTime)
  };
}

function clamp(v) {
  // Negative values are possible (clock skew, paint-before-fetch on bfcache);
  // floor to 0 so the column's UInt-derived percentile aggregations don't
  // choke.
  return v > 0 ? v : 0;
}
